import { render } from "./AButton.vue?vue&type=template&id=afce128a&scoped=true"
import script from "./AButton.vue?vue&type=script&lang=js"
export * from "./AButton.vue?vue&type=script&lang=js"

import "./AButton.vue?vue&type=style&index=0&id=afce128a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afce128a"]])

export default __exports__